import React, { useState } from 'react';
import { Modal } from '../common/Modal';
import { GuideForm } from './forms/GuideForm';
import { useGuidesStore } from '../../stores/guidesStore';
import { Guide } from '../../types/guide';
import toast from 'react-hot-toast';
import { useLanguage } from '../../contexts/LanguageContext'; // Added import

type Props = {
  isOpen: boolean;
  onClose: () => void;
  guide: Guide;
};

export const EditGuideModal = ({ isOpen, onClose, guide }: Props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const { updateGuide } = useGuidesStore();
  const { translations } = useLanguage(); // Added useLanguage hook

  const handleSubmit = async (data: Partial<Guide>) => {
    if (!data.name || !data.organizerId) {
      setError(translations?.editGuideModal?.requiredFieldsError || 'All fields are required');
      return;
    }

    setIsLoading(true);
    setError('');

    try {
      await updateGuide(guide.id, {
        ...data,
        updatedAt: Date.now(),
      });
      toast.success(translations?.editGuideModal?.updateSuccess || 'Guide updated successfully');
      onClose();
    } catch (err: any) {
      setError(err.message || translations?.editGuideModal?.updateError || 'Failed to update guide');
      toast.error(translations?.editGuideModal?.updateError || 'Failed to update guide');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={translations?.editGuideModal?.title || 'Edit Guide'}
    >
      {error && (
        <div className="mb-4 p-3 bg-red-50 text-red-600 rounded-lg text-sm">
          {error}
        </div>
      )}
      <GuideForm
        onSubmit={handleSubmit}
        initialData={guide}
        isLoading={isLoading}
        isEditing
      />
    </Modal>
  );
};